<template>
  <egg-label-list
    title="services.corporatePackages"
    titleColor="#603813"
    :starIconObj="{ componentName: 'shared', imgName: 'starIconGreen', imgFormat: 'svg' }"
    :starBackgroundObj="{ componentName: 'shared', imgName: 'starGroupIconBrownLeft', imgFormat: 'svg', position: 'top:50%' }"
    labelColor="#4E4E4E"
    :eggIconLabelList="servicesStore.eggDescList"
    class="pb-24"
  />
</template>

<script setup lang="ts">
import { useServicesStore } from "@/stores/services";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";

const servicesStore = useServicesStore();
const router = useRouter();

onMounted(async () => {});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>